import React, { Component } from 'react';
import * as IconList from './icons/icons';

interface IconProps {
    name?: keyof typeof IconList;
    className?: string;
    [key: string]: unknown;
}

class Icon extends Component<IconProps> {
    _getIcon() {
        const iconName = this.props.name || 'Menu';
        const IconComponent = IconList[iconName] as React.ComponentType<Record<string, unknown>>;
        return <IconComponent {...this.props} />;
    }

    render() {
        return this._getIcon();
    }
}

export default Icon;
